import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  readonly baseLinkFilter = 'https://it-ioos.eu/api/DownloadSurveyConfig/';
  public filters = new Subject<any>();

  constructor(private http: HttpClient) { }


  public sendFilter(filter: any){
      this.filters.next(filter);
  }

  public getLoggedfilter(authid:string){
    return this.http.get(this.baseLinkFilter + 'DownloadSurvey/' + authid);
  }

  public saveLoggedFilter(filters:string, authid:string){
    const objToSave = {
      value: filters,
      authId: authid
    }
    const body = JSON.stringify(objToSave);
    return this.http.put(this.baseLinkFilter + 'Upsert', objToSave);
  }

}
